import React from 'react';
import { observer } from 'mobx-react';
import { DefaultRoute, withRouter } from 'react-router-dom'
import { withApollo } from "react-apollo";
import PageTitle from "../../components/PageTitle";
import TabsComponent from "../../components/fields/TabsComponent";
import TabsData from "../../layout/TabsData";
import PageTitleRightModal from "../../components/PageTitleRightModal";
import PropsUtil from "../../util/PropsUtil";
import InfoBlock from "../../components/InfoBlock";
import util from '../../util/Util'
import BaseForm from "../base/BaseForm";
import HistoryComponent from "../../components/HistoryComponent";
import ClientModel from "../../models/ClientModel";
import withTranslate from "../../translator/withTranslate";

@observer
class ClientHistory extends BaseForm {
    nameMainType = "client";

    constructor(props) {
        super(props);
        this.tabsData = new TabsData();
    }

    getModelQuery() {
        return new ClientModel();
    }

    getFormId() {
        let id = super.getFormId();
        if (this.props.clientId != null) {
            id = this.props.clientId;
        }
        return id;
    }
    onCloseModal() {
        return this.propsUtil.changeUrlRequest({
            rightModal: null,
            idWorkOrder: null,
            rightModalTab: null,
            idOrderClient: null,
            orderId: null,
            workOrderId: null

        });
    }

    render() {
        this.propsUtil = new PropsUtil(this.props);
        let modalClasses = util.getModalClasses();
        let client = this.graphDataMainType;
        const { t, i18n } = this.props;

        return (
            <div className={this.props.fromRightModal ? modalClasses.push : ""}>
                <InfoBlock componentObject={this}>

                    {this.props.fromRightModal ?

                        <div className={modalClasses.head}>
                            <PageTitleRightModal
                                title={"Cliente"}
                                subtitle={(this.isPos == 0 ? client.companyName : client.name) + " " + client.code}
                                mode={"view"}
                                onCloseModal={() => this.onCloseModal()}
                            />
                            <TabsComponent
                                id={this.getFormId()}
                                tabs={this.graphDataMainType.isPos == 1 ? this.tabsData.getDataClientPos() : this.tabsData.getDataClient()}
                                active={"Histórico"}
                                fromRightModal={this.props.fromRightModal}
                            />
                        </div>
                        :
                        <PageTitle
                            title={"Cliente"}
                            subtitle={(this.isPos == 0 ? client.companyName : client.name) + " " + client.code}
                        />
                    }

                    <div className="card mb-3">
                        {!this.props.fromRightModal &&
                        <TabsComponent
                            id={this.getFormId()}
                            tabs={this.graphDataMainType.isPos == 1 ? this.tabsData.getDataClientPos() : this.tabsData.getDataClient()}
                            active={"Histórico"}
                        />
                        }
                        <div className="card-body">
                            <HistoryComponent
                                id={this.getFormId()}
                                modelo={this.getModelQuery()}
                            />


                        </div>

                    </div>
                </InfoBlock>
            </div>
        );
    }

}

export default withRouter(withApollo(withTranslate(ClientHistory)));
